/*
 * MDB shim for MDBCollapseHeader
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Pipeline/MonthGlance.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 */

import MUIBox from "@mui/material/Box";

export default function MDBCollapseHeader({ children, ...rest }) {
  return <MUIBox {...rest}>{children}</MUIBox>;
}
